import { limits } from '../limits-store.js';
import { ago, humanTime } from '../ui.js';

// Что осталось у платных источников: остаток на счёте распознавания, окно
// запросов у второго движка, состояние очереди и подписки агентов.
//
// Данные живут в сторе и переживают уход на другую вкладку: раньше они лежали
// в компоненте, и человек, вернувшись, видел пустой экран с кнопкой — будто и
// не запрашивал ничего минуту назад.

export const Limits = {
  computed: {
    s() { return limits; },
    // Часы и минуты по местным часам: вопрос не «в какую секунду», а «не
    // устарело ли». Полная дата с секундами и UTC читалась как отчёт сервера.
    checked() {
      if (!limits.at) return '';
      const d = new Date(limits.at);
      const p = (n) => String(n).padStart(2, '0');
      return `${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    // «Пять минут назад» понятнее точного времени: вопрос ведь не «когда», а
    // «не устарело ли».
    age() { return limits.at ? ago(limits.at) : ''; },
    /** Точное время — в подсказке: там ему и место. */
    exact() { return limits.at ? humanTime(limits.at) : ''; },
  },
  methods: {
    load() { return limits.load(); },
  },
  template: `
    <div>
      <div class="row" style="margin-bottom:14px">
        <button class="primary" @click="load" :disabled="s.loading">
          {{ s.loading ? 'Спрашиваю…' : (s.at ? 'Обновить' : 'Показать остатки') }}
        </button>
        <span class="faint" v-if="s.at" :title="exact">
          данные на {{ checked }} ({{ age }}) — обновятся только по кнопке
        </span>
      </div>

      <p class="err" v-if="s.error">{{ s.error }}</p>

      <p class="note" v-if="!s.at && !s.loading">
        Здесь остаток на счёте распознавания, окно запросов у второго движка,
        состояние очереди заданий и подписки агентов. Цифры живут в чужих API,
        поэтому спрашиваются по кнопке, а не сами.
      </p>

      <div class="card lim" v-for="x in s.sources" :key="x.id">
        <span class="chk" :class="x.state === 'ok' ? 'up' : (x.state === 'fail' ? 'down' : 'wait')"><i></i></span>
        <div class="lim-body">
          <b>{{ x.name }}</b>
          <span class="faint">{{ x.detail }}</span>
        </div>
        <span class="lim-value" :class="x.state">{{ x.value }}</span>
      </div>

      <!-- Состояние процесса: держатели объявляют свои части сами, здесь опись.
           Нужна не из любопытства — забытая запись в «ждут ответа агента» это
           собес, который уже не продолжится. -->
      <template v-if="s.memory.length">
        <h2 style="margin-top:26px">В памяти сервера</h2>
        <div class="card lim" v-for="m in s.memory" :key="m.id">
          <div class="lim-body">
            <b>{{ m.id }}</b>
            <span class="faint">{{ m.about }}</span>
          </div>
          <span class="lim-value">
            {{ m.size }}<i class="faint" style="font-size:13px;font-style:normal" v-if="m.detail"> · {{ m.detail }}</i>
          </span>
        </div>
      </template>
    </div>`,
};
